import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { StandingConfigurationResponse } from "~types/standingConfiguration.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
};

export const useFetchStandingsConfigurations = ({ customParams }: Props) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["standingsConfigurations", sport, organizationId, customParams],
    queryFn: () =>
      request<StandingConfigurationResponse>(`${sport}/o/${organizationId}/standings/configurations?${params.toString()}`).then(
        (response) => transformListResponse(response),
      ),
  });
};
